import React from 'react';
import PropTypes from 'prop-types';

/**
 * Reusable Accordion Component
 * Simple, lightweight accordion without Bootstrap dependencies
 * 
 * @param {string} title - The title displayed in the accordion header
 * @param {boolean} isOpen - Whether the accordion is currently open
 * @param {function} onToggle - Callback function when accordion is clicked
 * @param {node} children - Content to display when accordion is open
 */
const AccordionItem = ({ title, isOpen, onToggle, children }) => (
  <div className="card mb-2">
    <div 
      className="card-header" 
      style={{ cursor: 'pointer', backgroundColor: '#f8f9fa' }}
      onClick={onToggle}
    >
      <div className="d-flex justify-content-between align-items-center">
        <span>{title}</span>
        <span>{isOpen ? '−' : '+'}</span>
      </div>
    </div>
    {isOpen && (
      <div className="card-body">
        {children}
      </div>
    )}
  </div>
);

AccordionItem.propTypes = {
  title: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  children: PropTypes.node
};

export default AccordionItem;

